import { gql } from "@apollo/client";

export const GET_REQUEST = gql(`
    query Requests($id: ID!) {
        requests(id: $id) {
            data {
                id
                source_type
                source_id
                type
                invoice_status
                in_out_storage
                pickup_and_delivery_date
                state
                stateFlow {
                    completed
                    cancelled
                    value
                    type
                }
                invoiced
                freestock
                work_order_number
                comment
                is_from_dbb_api
                availableTransitions
                created_at
                updated_at
                active
                user {
                    id
                }
                relation {
                    id
                    name
                }
                requestTires {
                    id
                    tire {
                      id
                      label
                      status
                    }
                }
                source {
                    __typename
                    ... on Tire {
                        id
                    }
                    ... on Tireset {
                        id
                        type
                        sleep_set
                        in_hotel
                        sticker {
                          pdfUrl
                        }
                        tires {
                            id
                            label
                            brand
                            brand_type
                            type
                            ean
                            profile_depth
                            size
                            run_flat
                            car_position
                            status
                        }
                        car {
                            id
                            licence
                            label
                            status
                            relation {
                            id
                            }
                        }
                    }
                }
                packingSlip {
                  id
                  date
                  label
                }
            }
        }
    }

`);

export const GET_ALL_STATES = gql(`
    query AllRequestStates {
        allRequestStates {
            pickupStates
            deliverStates
        }
    }
`);

export const GET_PICKUP_DELIVERY_DATES = gql`
  query getPickupDeliveryDates {
    getPickupDeliveryDates {
      firstDate
      forbiddenDates
    }
  }
`;
